import { styled } from '@mui/material/styles';
import { createChunks } from '@shared/utils/array';
import type { TimeZone } from '@shared/utils/date';
import type { DateRange, LabeledPreset } from '../types';
import { PresetButton } from './PresetButton';

interface PresetListProps {
  activePreset?: LabeledPreset;
  onChange: (value: DateRange) => void;
  presets: readonly LabeledPreset[];
  timeZone?: TimeZone;
}

const ListContainer = styled('div', { name: 'DateRangePickerPresetList' })(
  ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  })
);

const ListRow = styled('div', { name: 'DateRangePickerPresetListRow' })(
  ({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  })
);

export function PresetList({
  activePreset,
  onChange,
  presets,
  timeZone,
}: PresetListProps) {
  const chunks = createChunks([...presets], 2);

  return (
    <ListContainer>
      {chunks.map((chunk, i) => (
        <ListRow key={i}>
          {chunk.map((preset) => (
            <PresetButton
              key={preset.id}
              active={activePreset?.id === preset.id}
              onClick={onChange}
              preset={preset}
              timeZone={timeZone}
            />
          ))}
        </ListRow>
      ))}
    </ListContainer>
  );
}
